import { createAction, createAsyncAction } from "typesafe-actions";
import { BankAccount, Card } from "../../models/billing";

export const fetchBankAccountsAsync = createAsyncAction(
  "FETCH_BANK_ACCOUNTS_REQUEST",
  "FETCH_BANK_ACCOUNTS_SUCCESS",
  "FETCH_BANK_ACCOUNTS_FAILURE"
)<undefined, BankAccount[], string>();

export const linkBankAccountAsync = createAsyncAction(
  "LINK_BANK_ACCOUNT_REQUEST",
  "LINK_BANK_ACCOUNT_SUCCESS",
  "LINK_BANK_ACCOUNT_FAILURE"
)<{ publicToken: string; accountId: string }, BankAccount, string>();

export const fetchCardsAsync = createAsyncAction(
  "FETCH_CARDS_REQUEST",
  "FETCH_CARDS_SUCCESS",
  "FETCH_CARDS_FAILURE"
)<undefined, Card[], string>();

export const createCardAsync = createAsyncAction(
  "CREATE_CARD_REQUEST",
  "CREATE_CARD_SUCCESS",
  "CREATE_CARD_FAILURE"
)<{ token: string }, Card, string>();

export const createDepositAsync = createAsyncAction(
  "CREATE_DEPOSIT_REQUEST",
  "CREATE_DEPOSIT_SUCCESS",
  "CREATE_DEPOSIT_FAILURE"
)<{ accountId: string; sourceId: string; amount: number }, string, string>();

export const createDepositClear = createAction("CREATE_DEPOSIT_CLEAR")();

export const createRecurringDepositAsync = createAsyncAction(
  "CREATE_RECURRING_DEPOSIT_REQUEST",
  "CREATE_RECURRING_DEPOSIT_SUCCESS",
  "CREATE_RECURRING_DEPOSIT_FAILURE"
)<
  { accountId: string; sourceId: string; startDate: string; amount: number },
  string,
  string
>();

export const createRecurringDepositClear = createAction("CREATE_RECURRING_DEPOSIT_CLEAR")();
